module.exports = new __parcel__URL__("apply_k_ko.dca74252.webp").toString();